// import './components/search/search.js';
// import './components/slider/slider.js';
// import './components/slider-swiffy/swiffy-slider.min.js';
// import '../../../gutenberg/latestwins/assets/latestwins.js';
import '../../../template-parts/frame/assets/js/index.js'

//import '../../../gutenberg/slider-banner/assets/slider-banner.js';

// import "../../../blocks/comments-rating/assets/comments-rating.js";
// import "../../../blocks/demo/assets/demo.js";
// import "../../../blocks/payment-methods/assets/payment-methods.js";
// import "../../../blocks/toc/assets/toc.js";
// import "../../../blocks/video/assets/video.js";
// import "../../../blocks/winning-now/assets/winning-now.js";